import * as React from "react";
export class CloseButton extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "rj-popup-message__close-btn", onClick: this.props.onClick, "data-uat": "popup-message-close-btn" },
            React.createElement("span", { className: "rj-popup-message__close-btn--icon" })));
    }
}
//# sourceMappingURL=CloseButton.js.map